export const DISTRICTS = 'districts',
	QUESTIONS = 'questions',
	SCHOOLS = 'schools',
	ASSESSMENTS = 'assessments',
	RESULTS = 'results';
